import { FunctionComponent } from 'react'
import {
  RFPDocumentSummary,
  RFPSortBy,
  SiteRFPPhaseAPIResponse,
} from '@black-bear-energy/black-bear-energy-common'
import { Typography } from '@black-bear-energy/rucksack'
import { Surface } from '../common/Surface'
import { SearchableTable } from './SearchableTable'

const SORT_BY_DISPLAY_NAMES: Record<RFPSortBy, string> = {
  [RFPSortBy.RFPName]: 'Project Name',
  [RFPSortBy.SystemSize]: 'System Size',
  [RFPSortBy.LastUpdated]: 'Last Updated',
}

export const CustomerRFPList: FunctionComponent<CustomerRFPListProps> = ({
  rfpDocumentSummaries,
  isPending,
  search,
  setSearch,
  requiredMissing,
  setRequiredMissing,
  reviewMissing,
  setReviewMissing,
  phase,
  setPhase,
  sortBy,
  setSortBy,
  sortAsc,
  setSortAsc,
  page,
  setPage,
  totalPages,
}: CustomerRFPListProps) => {
  const isSortResetDisabled = sortBy === RFPSortBy.RFPName && sortAsc === true
  const handleResetSort = () => {
    setSortBy(RFPSortBy.RFPName)
    setSortAsc(true)
  }

  return (
    <>
      <Surface>
        <Typography variant="h5">Document Exchange</Typography>
      </Surface>

      <SearchableTable
        variant="customerRFP"
        records={rfpDocumentSummaries}
        isPending={isPending}
        search={search}
        setSearch={setSearch}
        requiredMissing={requiredMissing}
        setRequiredMissing={setRequiredMissing}
        reviewMissing={reviewMissing}
        setReviewMissing={setReviewMissing}
        phase={phase}
        setPhase={setPhase}
        page={page}
        setPage={setPage}
        totalPages={totalPages}
        sort={{
          sortBy,
          setSortBy,
          sortAsc,
          setSortAsc,
          handleReset: handleResetSort,
          resetDisabled: isSortResetDisabled,
          displayNames: SORT_BY_DISPLAY_NAMES,
          showSortByLabel: true,
        }}
      />
    </>
  )
}

export interface CustomerRFPListProps {
  rfpDocumentSummaries?: RFPDocumentSummary[]
  isPending: boolean
  search: string
  setSearch: (search: string) => void
  requiredMissing: boolean
  setRequiredMissing: (requiredMissing: boolean) => void
  reviewMissing: boolean
  setReviewMissing: (reviewMissing: boolean) => void
  phase: SiteRFPPhaseAPIResponse[]
  setPhase: (phase: SiteRFPPhaseAPIResponse[]) => void
  sortBy: RFPSortBy
  setSortBy: (sortBy: RFPSortBy) => void
  sortAsc: boolean
  setSortAsc: (sortAsc: boolean) => void
  page: number
  setPage: (page: number) => void
  totalPages: number
}
